import styled from "styled-components";

import { colorsPalettes, fonts } from "@similarweb/styles";

import { StyledFadeIn } from "../../../../common-components/styles";

export const StyledText = styled.span`
    color: ${colorsPalettes.carbon["300"]};
    font-family: ${fonts.$robotoFontFamily};
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    margin-right: 8px;
`;

export const StyledQuotaContainer = styled(StyledFadeIn)`
    align-items: center;
    background-color: transparent;
    border-radius: 6px;
    cursor: default;
    display: inline-flex;
    padding: 8px 24px 8px 8px;
    user-select: none;
`;

export const StyledTooltipContent = styled.div`
    cursor: pointer;
`;
